import Plyr from 'plyr';
import PubSub from "underpub-js";

var VideoModal = function (options) {

	this.options = {
		$el: false
	};

	$.extend(true, this.options, options);

};

VideoModal.prototype.init = function () {

	var self = this;

	// Our global show method
	PubSub.subscribe("VideoModal.show", function(options){
		self.show(options.videoUrl);
	});

	// Hiding our modal
	this.options.$el.on("click", function(evt){
		var $target = $(evt.target);
		if($target.is(".bg-container")){
			self.hide();
		}
	});

};

VideoModal.prototype.show = function (videoUrl) {

	var self = this;

	this.$playerEl = this.options.$el.find(".player");
	this.$playerEl.attr("data-plyr-embed-id", videoUrl);

	this.$player = new Plyr(this.$playerEl[0], {
		controls: ['play-large'],
		hideControls: true,
		tooltips: false,
		disableContextMenu: true,
		youtube: { noCookie: false, rel: 0, showinfo: 0, iv_load_policy: 3, modestbranding: 1 }
	});

	// making sure the player is loaded before we start to play
	this.$readyToPlay = $.Deferred();
	this.$player.on('ready', event => {
		self.$readyToPlay.resolve();
	});

	// giving it a little time to load
	setTimeout(function(){
		self.options.$el.addClass("is-active");
		setTimeout(function(){
			self.$readyToPlay.done(function(){
				if(window.Breakpoint.value !== "xsmall" && window.Breakpoint.value !== "small"){
					self.$player.play();
				}
			});
		}, 1000);
	}, 500);

};

VideoModal.prototype.hide = function () {

	var self = this;
	self.$player.stop();
	self.options.$el.removeClass("is-active");

	setTimeout(function(){
		self.$player.destroy();
	}, 400);

};

export default VideoModal;
